import PersonalApiKeysTableCreatedAtCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/CreatedAtCell";
import PersonalApiKeysTableExpiresAtCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/ExpiresAtCell";
import PersonalApiKeysTableIssuesCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/IssuesCell";
import PersonalApiKeysTableKeyIdCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/KeyIdCell";
import PersonalApiKeysTableLastUsedCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/LastUsedCell";
import PersonalApiKeysTableNameCell from "components/ApiKeys/PersonalApiKeys/Table/Cells/NameCell";

import { API_KEYS_PERSONAL_COLUMN_ID } from "../constants";
import ApiKeysPersonalTableActionsCell from "./ActionsCell";
import ApiKeysPersonalTableOwnerCell from "./OwnerCell";

export const API_KEYS_PERSONAL_TABLE_CELLS = {
  [API_KEYS_PERSONAL_COLUMN_ID.NAME]: PersonalApiKeysTableNameCell,
  [API_KEYS_PERSONAL_COLUMN_ID.ISSUES]: PersonalApiKeysTableIssuesCell,
  [API_KEYS_PERSONAL_COLUMN_ID.KEY_ID]: PersonalApiKeysTableKeyIdCell,
  [API_KEYS_PERSONAL_COLUMN_ID.OWNER]: ApiKeysPersonalTableOwnerCell,
  [API_KEYS_PERSONAL_COLUMN_ID.CREATED_AT]: PersonalApiKeysTableCreatedAtCell,
  [API_KEYS_PERSONAL_COLUMN_ID.EXPIRES_AT]: PersonalApiKeysTableExpiresAtCell,
  [API_KEYS_PERSONAL_COLUMN_ID.LAST_USED]: PersonalApiKeysTableLastUsedCell,
  [API_KEYS_PERSONAL_COLUMN_ID.ACTIONS]: ApiKeysPersonalTableActionsCell,
};
